/**
 * Servicio para manejar la comunicación con n8n
 */
class N8NService {
  /**
   * Crea una instancia del servicio n8n
   * @param {string} baseUrl - URL base de la API de n8n
   */
  constructor(baseUrl = typeof window !== 'undefined' ? window.location.origin : 'https://n8ndev.ia.sistran.com.co') {
    this.baseUrl = baseUrl;
  }

  /**
   * Envía una solicitud a un webhook de n8n
   * @param {string} endpoint - Endpoint del webhook
   * @param {Object} data - Datos a enviar
   * @param {Object} options - Opciones adicionales
   * @returns {Promise<Object>} Respuesta del servidor
   */
  async sendToWebhook(endpoint, data = {}, options = {}) {
    try {
      const url = endpoint.startsWith('http')
        ? endpoint
        : endpoint.startsWith('/')
          ? `${this.baseUrl}${endpoint}`
          : `${this.baseUrl}/${endpoint}`;
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(options.headers || {}),
        },
        body: JSON.stringify(data),
        ...options,
      });

      if (!response.ok) {
        // Intenta parsear error como texto o JSON
        const errorText = await response.text();
        let errorData = {};
        try {
          errorData = errorText ? JSON.parse(errorText) : {};
        } catch {
          errorData = { message: errorText };
        }
        throw new Error(
          errorData.message || `Error en la petición: ${response.status} ${response.statusText}`
        );
      }

      // Manejo robusto de respuesta vacía o no JSON
      const text = await response.text();
      let result = null;
      try {
        result = text ? JSON.parse(text) : {};
      } catch (e) {
        result = { message: text };
      }
      return result;
    } catch (error) {
      console.error('Error al enviar solicitud a n8n:', error);
      throw error;
    }
  }

  /**
   * Envía un mensaje al webhook del Asistente de Especificaciones Funcionales
   * @param {string} message - Mensaje del usuario
   * @param {Object} context - Contexto adicional
   * @returns {Promise<Object>} Respuesta del asistente
   */
  async sendLearningMessage(message, context = {}) {
    return this.sendToWebhook('/webhook/3db97ff9-f412-48fe-95ff-a507f8637022', {
      message,
      context: {
        timestamp: new Date().toISOString(),
        ...context,
      },
    });
  }
}

// Exportar una instancia preconfigurada
export const n8nService = new N8NService();

// Exportar la clase para permitir su uso con configuraciones personalizadas
export default N8NService;